module.exports = __webpack_public_path__ + "img/fflofficelogosimple.6619a2b3.svg";